<template>
  <v-dialog
    :value="value"
    @click:outside="handleCancel"
    @cancel="handleCancel"
    width="600px"
  >
    <v-card>
      <v-form ref="form-document">
        <v-card-title class="headline">{{ title }} </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-text-field
                v-model="field.name"
                :rules="rules.name"
                :label="$t('commons.name')"
                counter="64"
                maxlength="64"
                outlined
              >
              </v-text-field>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="handleSave"
            >{{ $t("commons.save") }}</v-btn
          >
          <v-btn
            color="error"
            @click="handleCancel"
            >{{ $t("commons.cancel") }}</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import DocumentationService from "@/services/DocumentationService"
import { required } from "@/utils/validator"

export default {
  name: "EditDocumentDialog",
  props: {
    item: {
      type: Object
    },
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: "Edit File"
    },
    isFolder: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      // field: { ...this.item }
      field: Object.assign({}, this.item)
    }
  },
  computed: {
    rules() {
      return {
        //name: [required, slug, max64],
        name: [required],
        type: [required],
        ...this.rulesUpdate
      }
    },
    projectId() {
      return this.$store.state.app.project.id
    }
  },
  methods: {
    validate() {
      return this.$refs["form-document"].validate()
    },
    handleCancel() {
      this.$emit("close", true)
    },
    handleSave() {
      if (this.validate()) {
        let promise = null
        let newName = this.field.name
        if (this.isFolder) {
          promise = DocumentationService.renameFolder(this, this.projectId, this.item.id, newName)
        } else {
          promise = DocumentationService.renameDocument(this, this.projectId, this.item.id, newName)
        }

        return promise
          .then(response => {
            this.notify(this.$t("messages.success.edited", { entity: this.$tc("commons.file", 1) }))
            this.$emit("close", true)
            this.$emit("hasChanged", true)
            return true
          })
          .catch(error => {
            this.$emit("close", true)
            this.notify(error.message, "error")
            return false
          })
      }
    },
    notify(msg, color = "success") {
      this.$store.commit("app/message", { msg, color })
    }
  }
}
</script>
